<template>
  <div class="rounded-lg border border-cyan-400/25 bg-slate-950/35 p-3 space-y-3">
    <h4 class="text-sm font-medium text-slate-200">Executores permitidos</h4>
    <div class="flex items-center gap-2">
      <AgentAsyncPicker
        ref="executorPicker"
        kind="executor"
        :omit-ids="form.allowed_executor_ids || []"
        :exclude-specialties="coordinatorExecutorExcludeSpecialties"
        placeholder="Buscar executor por nome…"
        @select="executorDraft = $event"
        @clear="executorDraft = null"
      />
      <button
        type="button"
        class="whitespace-nowrap text-xs px-2 py-2 rounded border border-cyan-400/40 text-cyan-200 hover:bg-cyan-400/10 disabled:opacity-40 disabled:pointer-events-none"
        :disabled="!executorDraft"
        @click="confirmAddExecutor"
      >
        Adicionar
      </button>
    </div>
    <div class="flex flex-wrap gap-2">
      <span
        v-for="id in form.allowed_executor_ids"
        :key="`executor-${id}`"
        class="inline-flex items-center gap-2 px-2 py-1 rounded border border-cyan-400/30 bg-cyan-400/10 text-cyan-100 text-xs"
      >
        {{ labelForExecutor(id) }}
        <button type="button" class="text-cyan-200 hover:text-white" @click="$emit('remove-executor', id)">×</button>
      </span>
    </div>
  </div>
</template>

<script>
import AgentAsyncPicker from './AgentAsyncPicker.vue'

/** Executores com estas especialidades não podem ser ligados ao coordenador (alinhado ao backend). */
const COORDINATOR_EXECUTOR_EXCLUDE_SPECIALTIES = ['email_analyst']

export default {
  name: 'AgentCoordinatorConfigForm',
  components: { AgentAsyncPicker },
  props: {
    form: { type: Object, required: true },
    executorSummaries: { type: Array, default: () => [] },
    editingId: { type: [Number, String, null], default: null }
  },
  emits: ['add-executor', 'remove-executor'],
  data() {
    return {
      executorDraft: null,
      coordinatorExecutorExcludeSpecialties: [...COORDINATOR_EXECUTOR_EXCLUDE_SPECIALTIES]
    }
  },
  watch: {
    editingId() {
      this.executorDraft = null
      this.$refs.executorPicker?.reset?.()
    }
  },
  methods: {
    labelFromSummaries(summaries, id) {
      const n = Number(id)
      const row = (summaries || []).find((o) => Number(o.id) === n)
      return row?.label || row?.name || null
    },
    labelForExecutor(id) {
      return this.labelFromSummaries(this.executorSummaries, id) || `Executor #${id}`
    },
    confirmAddExecutor() {
      if (!this.executorDraft) return
      this.$emit('add-executor', this.executorDraft)
      this.executorDraft = null
      this.$refs.executorPicker?.reset?.()
    }
  }
}
</script>
